import { gql } from 'apollo-boost'

const RESOLVE_DISH_REVIEW_TASK_BY_REJECT_AI_MENU = gql`
  mutation resolveDishReviewTaskByRejectAiMenu(
    $id: ID!
    $scrapingRejectedComment: String!
  ) {
    resolveDishReviewTaskByRejectAiMenu(
      id: $id
      scrapingRejectedComment: $scrapingRejectedComment
    ) {
      id
    }
  }
`

export default RESOLVE_DISH_REVIEW_TASK_BY_REJECT_AI_MENU
